const countries = [
  { value: 'US', alphaCode: 'USA', label: 'United States' },
  { value: 'CA', alphaCode: 'CAN', label: 'Canada' },
  { value: 'AU', alphaCode: 'AUS', label: 'Australia' },
  { value: 'MX', alphaCode: 'MEX', label: 'Mexico' },
  { value: 'NZ', alphaCode: 'NZL', label: 'New Zealand' },
  { value: 'CO', alphaCode: 'NZL', label: 'Colombia' },
];

const countriesCode = [
  { value: 'USA', label: 'United States' },
  { value: 'CAN', label: 'Canada' },
  { value: 'AUS', label: 'Australia' },
  { value: 'MEX', label: 'Mexico' },
  { value: 'NZL', label: 'New Zealand' },
  { value: 'COL', label: 'Colombia' },
];

export { countries, countriesCode };
